import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-alert-box',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})
export class AlertBoxComponent {
  type = input<'info' | 'warning' | 'error' | 'success'>('info');
  title = input();

  getIcon(type: string): string {
    switch (type) {
      case 'warning':
        return 'triangle-exclamation';

      case 'error':
        return 'circle-info-warning';

      case 'success':
        return 'check';

      default:
        return 'circle-info';
    }
  }
}
